export default __webpack_public_path__ + "static/media/youngs-modulus.108e48fb.jpg";